import React from "react";
import "../../css/Features.css";

import service_1 from "../../assets/service_1.png"
import service_2 from "../../assets/service_2.png"
import service_3 from "../../assets/service_3.png"
import service_4 from "../../assets/service_4.png"
import service_5 from "../../assets/service_5.png"
import service_6 from "../../assets/service_6.png"
import thumbnail from "../../assets/video-thumbnail.jpg";
import video from "../../assets/goldcleats_ai_demo.mp4";


const Features = () => {
  return (
    <div className="container features-container" style={{ color: '#EEEEF0' }}>

      <header className="header">
        <div className="row header-content">
          <div className="col-lg-6">
            <div className="video-container">
              {/* Local Video Embed */}
              <video width="100%" height="auto" controls poster={thumbnail}>
                <source src={video} type="video/mp4" />
                Your browser does not support the video tag.
              </video>
            </div>
          </div>
          <div className="col-lg-5">
            <div className="header-text">
              <h1 className="text-center title">Our Features</h1>
              <p className="subtitle">
                Unlock the power of AI-driven search, proprietary data insights, and exclusive content. Secure, share, and customize your experience with advanced tools and dedicated support.
              </p>
            </div>
          </div>
        </div>
      </header>




      {/* <header className="header">
        <h1 className="text-center title">Our Features</h1>
        <p className="subtitle">Unlock the power of AI-driven search, proprietary data insights, and exclusive content. Secure, share, and customize your experience with advanced tools and dedicated support.</p>
      </header> */}
      <div className="row">
        <section className="features-section-container">
          <div className="features">
            <div className="feature">
              <img width={50} src={service_1} loading="lazy" alt="" />
              <h3>Advanced AI-powered Search</h3>
              <p>
                Explore talented players from around the globe with advanced AI recommendations.
              </p>
            </div>
            <div className="feature">
              <img width={50} src={service_2} loading="lazy" alt="" />
              <h3>Proprietary Data Feeds</h3>
              <p>
                Gain deep insights into player performance metrics and comparisons.
              </p>
            </div>
            <div className="feature">
              <img width={50} src={service_3} loading="lazy" alt="" />
              <h3>Text, Video, & Exclusive Content Responses</h3>
              <p>
                Leverage data-driven decisions to make smarter soccer scouting choices.
              </p>
            </div>
            <div className="feature">
              <img width={50} src={service_4} loading="lazy" alt="" />
              <h3>Download & Share Your Searches</h3>
              <p>
                Seamlessly save and share your searches to collaborate and stay organized.
              </p>
            </div>
            <div className="feature">
              <img width={50} src={service_5} loading="lazy" alt="" />
              <h3>Security & Compliance</h3>
              <p>
                Ensure your data's safety with robust security and compliance measures.
              </p>
            </div>
            <div className="feature">
              <img width={50} src={service_6} loading="lazy" alt="" />
              <h3>Custom Support</h3>
              <p>
                Our team is always ready to assist you with exceptional support and expertise.
              </p>
            </div>
          </div>
        </section>
      </div>
    </div>

  );
};

export default Features;
